@if (selectedOrder) {
  <div class="animate-in-from-right">
    <myp-order-detail [order]="selectedOrder" (goBackClicked)="selectedOrder = null"></myp-order-detail>
  </div>
}
@if (!selectedOrder) {
  <div class="fui-heading-container">
    <fui-heading [text]="'header.nav.orders' | translate" [level]="5"></fui-heading>
    <button class="fui-action-btn" (click)="appService.goToFenderShop('', true)">
      <fa-icon icon="shopping-cart"></fa-icon>
      {{ "orders.go_shopping" | translate }}
    </button>
  </div>
  @if (!loading && !orders?.length) {
    <div class="m-y-20 text-muted">{{ "orders.no_orders_to_display" | translate }}</div>
  }
  @if (!loading && orders?.length) {
    <div class="m-y-20">
      <myp-product-filter
        theme="neutral"
        #filterCmp
        [titleWord]="'orders.product' | translate"
        (filterChanged)="filterOrders($event)"
        (sortChanged)="sortOrders()"
        [showSortType]="true"
        [showListGrid]="false"
      ></myp-product-filter>
    </div>
    <div class="fui-orders-list desktop-only">
      <div class="fui-orders-header m-t-20">
        <div class="fui-orders-col">{{ "orders.order" | translate }}</div>
        <div class="fui-orders-col grow">{{ "orders.product" | translate }}</div>
        <div class="fui-orders-col">{{ "orders.order_date" | translate }}</div>
        <div class="fui-orders-col">{{ "orders.payment_status" | translate }}</div>
        <div class="fui-orders-col">{{ "orders.status" | translate }}</div>
        <div class="fui-orders-col">{{ "orders.total" | translate }}</div>
      </div>
      @for (order of filteredOrders; track order) {
        <div class="fui-order-item" mode="button" (click)="selectOrder(order)" tabindex="0">
          <div class="fui-orders-col">{{ order.name }}</div>
          <div class="fui-orders-col grow">{{ order.description }}</div>
          <div class="fui-orders-col">{{ order.date | date }}</div>
          <div class="fui-orders-col">{{ order.paymentStatus | sentenceCase }}</div>
          <div class="fui-orders-col">{{ order.fulfillmentStatus | sentenceCase }}</div>
          <div class="fui-orders-col">{{ order.total | currency: order.currency }}</div>
        </div>
      }
    </div>
    <div class="fui-orders-list mobile-only m-t-20">
      @for (order of filteredOrders; track order) {
        <div class="fui-mobile-order-item" mode="button" (click)="selectOrder(order)" tabindex="0">
          <span class="bold">{{ order.name }}</span>
          <div class="text-end">
            {{ order.date | date }}
            <br />
            <span class="text-muted t-14">{{ order.total | currency: order.currency }}</span>
          </div>
        </div>
        <hr />
      }
    </div>
  }
  @if (loading) {
    <myp-skeleton-loader type="list-item" [number]="5" extraContainerClass="m-y-20"></myp-skeleton-loader>
  }
}
